import { BezierCurve, ParticleTrail, ParticleTrailSpecification } from '@1x2network/particle_trail'
import { Container, Point } from 'pixi.js'
import { ShapeOptions } from '../types/ShapeOptions'
import { makeShape } from './shapes/makeShape'

/**
 * Helper functions relating to particle trails
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

interface ParticleTrailOptions {
    startPosition: Point
    endPosition: Point
    shape: ShapeOptions
    steps: number
    spec: ParticleTrailSpecification
    parent?: Container
}

/**
 * Helper function to create a ParticleTrail from a set of options
 * @param options ParticleTrailOptions
 * @returns ParticleTrail
 */
export function createParticleTrail(options: ParticleTrailOptions): ParticleTrail {
    const { spec, startPosition, endPosition, shape: shapeOptions, steps } = options
    const shape = makeShape(shapeOptions.kind, shapeOptions.options)
    const points = shape.calculateControlPoints(startPosition, endPosition)

    const trail = new ParticleTrail(new BezierCurve(points, steps), {
        parent: options.parent,
        ...spec,
    })

    return trail
}
